export const DOMAIN_TYPES = {
  RETAIL: "RETAIL",
  ASSESSMENT: "ASSESSMENT",
  EDUCATION: "EDUCATION",
  INSTITUTION: "INSTITUTION",
  FLEX_OFFICE: "FLEX_OFFICE",
  SERVICES: "SERVICES",
  WAAS: "WAAS",
  DEFAULT: "DEFAULT",
  KRUMAGO: "KRUMAGO",
  COMMON: "COMMON"
};

export const DYNAMIC_TEMPLATE_DOMAINS = [
  DOMAIN_TYPES.EDUCATION,
  DOMAIN_TYPES.FLEX_OFFICE,
  DOMAIN_TYPES.RETAIL,
  DOMAIN_TYPES.WAAS
];
